import * as React from 'react';

import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import EmailIcon from '@mui/icons-material/Email';
import EventIcon from '@mui/icons-material/Event';
import ImageIcon from '@mui/icons-material/Image';
import SmsIcon from '@mui/icons-material/Sms';
import VideocamIcon from '@mui/icons-material/Videocam';
import VoicemailIcon from '@mui/icons-material/Voicemail';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ApEditorMode from '../../../../enums/ApEditorMode';
import { ApActionType } from '../../../../sic-lib/enums/ApActionType';
import { ApEditorActions } from '../../../../sic-lib/reducers/actionPlanEditorReducer';
import { useUserName } from '../../../../store/users';

const actions: {
    actionType: ApActionType;
    icon: any;
    tooltip: string;
}[] = [
    {
        actionType: ApActionType.displayEvent,
        icon: AssignmentTurnedInIcon,
        tooltip: 'Display event',
    },
    {
        actionType: ApActionType.email,
        icon: EmailIcon,
        tooltip: 'Email',
    },
    {
        actionType: ApActionType.picture,
        icon: ImageIcon,
        tooltip: 'Picture',
    },
    {
        actionType: ApActionType.sms,
        icon: SmsIcon,
        tooltip: 'SMS',
    },
    {
        actionType: ApActionType.task,
        icon: EventIcon,
        tooltip: 'Task',
    },
    {
        actionType: ApActionType.video,
        icon: VideocamIcon,
        tooltip: 'Video',
    },
    {
        actionType: ApActionType.voicemail,
        icon: VoicemailIcon,
        tooltip: 'Voicemail',
    },
];

interface Props {
    apEditMode: ApEditorMode;
    apDispatch: React.Dispatch<ApEditorActions>;
    /* TIP: contactId must not be undefined if editing typeof ApPlan */
    contactId: number | undefined;
    menuId: string;
    anchorEl: HTMLElement | null;
    onCloseHandler: () => void;
}

export default function MenuAddApActionRaw({
    menuId,
    anchorEl,
    onCloseHandler,
    apEditMode,
    apDispatch,
    contactId,
}: Props) {
    const userName = useUserName();

    const handleSelect = (event: React.MouseEvent<HTMLElement>) => {
        const { actionType } = event.currentTarget.dataset;

        if (actionType) {
            apEditMode === ApEditorMode.template
                ? apDispatch({
                      type: 'CREATE_TEMPLATE_ACTION',
                      actionType: actionType as ApActionType,
                  })
                : apDispatch({
                      type: 'CREATE_PLAN_ACTION',
                      actionType: actionType as ApActionType,
                      contactId: contactId as number,
                      assignedUser: userName,
                  });

            onCloseHandler();
        }
    };

    return (
        <Menu id={menuId} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onCloseHandler}>
            {actions.map(act => (
                <MenuItem
                    key={act.actionType}
                    data-action-type={act.actionType}
                    onClick={handleSelect}
                >
                    <ListItemIcon>{React.createElement(act.icon)}</ListItemIcon>
                    <ListItemText primary={act.tooltip} />
                </MenuItem>
            ))}
        </Menu>
    );
}
